exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fondo-top-bar {\r\n    background-color: #0072ff ;\r\n}\r\n.color-letra {\r\n    color: white;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/src/app/component/header/header.component.css
// module id = ../../../../../src/app/component/header/header.component.css
// module chunks = 1